import { render, staticRenderFns } from "./CasePrivate.vue?vue&type=template&id=71c715fa&"
import script from "./CasePrivate.vue?vue&type=script&lang=js&"
export * from "./CasePrivate.vue?vue&type=script&lang=js&"
import style0 from "./CasePrivate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports